import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import IntractionActionsList from '../../components/IntractionActionsList'
import StagesManager from '../../components/StagesManager'
import FixedView from '../../components/FixedView'

export default class NotebookTools extends Component {

    state = {}

    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.fiexView?.hideView()
    }

    changePageSubMenu = (title) => {
        this.stageManager.changeStage(title)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.tools = el} onClick={() => { this.toolsView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('notebook.Tools')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={(el) => (this.toolsView = el)} nodeRef={this.tools} xOffset={this.props.language == "fa" ? 215 : -10} bottomOffset={0} topOffset={0} maxWidth={260}   >
                    <div className="bg-white br-10 p-1 shadow-3">
                        <div className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}   >
                            <div className="mb-2">
                                {/* <IntractionActionsList language={this.props.language} data={{ title: "Spelling & grammar", sub: true, icon: "/assets/icons/applets/database/stages-purple.svg" }} /> */}
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Word count", shortcut: "Ctrl+Shift+C", icon: "/assets/icons/note/tool/word.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Review suggested edits", shortcut: "Ctrl+Alt+U", icon: "/assets/icons/note/tool/review.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Compare documents", icon: "/assets/icons/note/tool/compare.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Citations", icon: "/assets/icons/note/tool/citations.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Explore", shortcut: "Ctrl+Alt+Shift+I", icon: "/assets/icons/note/tool/explore.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Linked objects", icon: "/assets/icons/note/tool/link.svg" }} />
                                {/* <IntractionActionsList language={this.props.language} data={{ title: "Dictionary", shortcut: 'Ctrl+Shift+Y', icon: "/assets/icons/note/tool/stages-purple.svg" }} /> */}
                            </div>
                            <div className="py-2" style={{ borderTop: "1px solid #eee" }}  >
                                {/* <IntractionActionsList language={this.props.language} data={{ title: "Translate documents", check: true, icon: "/assets/icons/note/tool/stages-purple.svg" }} /> */}
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Voice Typing", shortcut: "Ctrl+Shift+S", icon: "/assets/icons/note/tool/mic.svg" }} />
                            </div>
                            <div className="pt-2" style={{ borderTop: "1px solid #eee" }}   >
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Notification settings", icon: "/assets/icons/note/tool/bell.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Preferences", icon: "/assets/icons/note/tool/preferences.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Accessibility", icon: "/assets/icons/note/tool/accessibility.svg" }} />
                            </div>
                        </div>
                    </div>
                </FixedView>
            </>
        )
    }
}
